<template>
  <v-menu>
    <template v-slot:activator="{ on, attrs }">
    <v-btn v-bind="attrs" v-on="on" small class="ml-2" outlined text :disabled="!canWrite || hasMultipleActiveWatchers">
        <v-icon class="mr-2" color="primary" small>mdi-pencil</v-icon>
        {{ $t('vmail.btn.editGreetAudio') }}
        <v-icon class="ml-2" color="primary">mdi-menu-down</v-icon>
      </v-btn>
    </template>
    <v-list dense>
      <v-list-item
        v-for="(menuItem, index) in menuItems"
        :key="index"
        style="display: -webkit-box !important;"
        class="context-menu-item-direct-message"
        v-show="menuItem.show"
        @click="onClick(menuItem)"
      >
        <v-list-item-icon>
        <v-icon :color="menuItem.color">{{menuItem.icon}}</v-icon>
        </v-list-item-icon>
        <v-list-item-title>{{ menuItem.title }}</v-list-item-title>
      </v-list-item>
    </v-list>
  </v-menu>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'voicemails-greetings-cardActions',
  props: {
    canReset: {
      type: Boolean,
      required: true
    },
    canRestore: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    ...mapGetters({
      currentUserID: 'settings/userID',
      vmboxWriteFor: 'permissions/vmboxWriteFor',
      canWriteCurrentUser: 'permissions/vmboxesWrite',
      vmWatcherUserID: 'voicemails/watcherUserID',
      vmWatcherSubscriberID: 'voicemails/watcherSubscriberID',
      activeWatchers: 'voicemails/activeWatchers'
    }),
    canWrite: function () {
      if (this.currentUserID === this.vmWatcherUserID) {
        return this.canWriteCurrentUser
      }
      return this.vmboxWriteFor(this.vmWatcherSubscriberID)
    },
    hasMultipleActiveWatchers: function () {
      return this.activeWatchers.length > 1
    },
    menuItems () {
      return [
        {
          title: this.$t('vmail.cfg.greeting.btnRestore'),
          key: 'restore',
          icon: 'mdi-history',
          color: 'default',
          show: this.canWrite && this.canRestore
        },
        {
          title: this.$t('vmail.cfg.greeting.btnUpload'),
          key: 'upload',
          icon: 'mdi-upload',
          color: 'default',
          show: this.canWrite
        },
        {
          title: this.$t('vmail.cfg.greeting.btnRecord'),
          key: 'record',
          icon: 'mdi-radiobox-marked',
          color: 'default',
          show: this.canWrite
        },
        {
          title: this.$t('vmail.cfg.greeting.btnTTS'),
          key: 'tts',
          icon: 'mdi-text-box',
          color: 'default',
          show: this.canWrite
        },
        {
          title: this.$t('vmail.cfg.greeting.btnReset'),
          key: 'reset',
          icon: 'mdi-lock-reset',
          color: 'default',
          show: this.canWrite && this.canReset
        }
      ]
    }
  },
  methods: {
    onClick (menuItem) {
      this.$emit(menuItem.key)
    }
  }
}
</script>

<style scoped>
</style>
